import React from 'react';
import { TextField } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IQuizFormInput, IQuizFormValues } from '../../../quiz.types';
import { StyledFieldError } from '../../../styles';

// ---------------------------------------------------------------------------
// Text (open question)
// RHF v6: register() returns a ref callback — pass via inputRef, not spread.
// ---------------------------------------------------------------------------
export function TextInput({ input }: { input: IQuizFormInput }): JSX.Element {
  const { t } = useTranslation();
  const { register, errors } = useFormContext<IQuizFormValues>();
  const error = (errors?.answers as any)?.[input.id]?.value?.message as
    | string
    | undefined;

  return (
    <div>
      <TextField
        name={`answers.${input.id}.value`}
        inputRef={register({
          required: input.isRequired
            ? (t('quiz.form.errors.required') as string)
            : false,
        })}
        multiline
        rows={3}
        variant="outlined"
        fullWidth
        error={!!error}
      />
      {error && <StyledFieldError>{error}</StyledFieldError>}
    </div>
  );
}
